"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.miscellaneousCauseMessages = exports.vascularDiseasesOfTheLiverCauseMessages = exports.metabolicLiverDiseaseCauseMessages = exports.malignantDiseaseOfTheLiverCauseMessages = exports.acuteLiverFailureCauseMessages = exports.hepatologyTypeMessages = exports.MiscellaneousCause = exports.VascularDiseasesOfTheLiverCause = exports.MetabolicLiverDiseaseCause = exports.MalignantDiseaseOfTheLiverCause = exports.AcuteLiverFailureCause = exports.HepatologyType = void 0;
const schema_1 = require("../../../../schema");
var HepatologyType;
(function (HepatologyType) {
    HepatologyType["HEPATOLOGY_NO_DISEASE"] = "hepatology_no_disease";
    HepatologyType["ACUTE_CHRONIC_LIVER_FAILURE"] = "acute_chronic_liver_failure";
    HepatologyType["NONALCOHOLIC_FATTY_LIVER_DISEASE"] = "nonalcoholic_fatty_liver_disease";
    HepatologyType["ALCOHOLIC_LIVER_DISEASE"] = "alcoholic_liver_disease";
    HepatologyType["MALIGNANT_DISEASE_OF_THE_LIVER"] = "malignant_disease_of_the_liver";
    HepatologyType["METABOLIC_LIVER_DISEASE"] = "metabolic_liver_disease";
    HepatologyType["VASCULAR_DISEASES_OF_THE_LIVER"] = "vascular_diseases_of_the_liver";
    HepatologyType["MISCELLANEOUS"] = "miscellaneous";
})(HepatologyType || (exports.HepatologyType = HepatologyType = {}));
var AcuteLiverFailureCause;
(function (AcuteLiverFailureCause) {
    AcuteLiverFailureCause["HEPATITIS_A"] = "hepatitis_A";
    AcuteLiverFailureCause["ACETAMINOPHEN"] = "acetaminophen";
    AcuteLiverFailureCause["AUTOIMMUNE_HEPATITIS"] = "autoimmune_hepatitis";
    AcuteLiverFailureCause["HEPATITIS_B"] = "hepatitis_B";
    AcuteLiverFailureCause["HEPATITIS_C"] = "hepatitis_C";
    AcuteLiverFailureCause["CRYPTOGENIC_DRUGS"] = "cryptogenic_drugs";
    AcuteLiverFailureCause["HEPATITIS_D"] = "hepatitis_D";
    AcuteLiverFailureCause["WILSONS_DISEASE"] = "wilsons_disease";
    AcuteLiverFailureCause["BUDD_CHIARI_SYNDROME"] = "budd_chiari_syndrome";
    AcuteLiverFailureCause["FATTY_INFILTRATION"] = "fatty_infiltration";
    AcuteLiverFailureCause["ACUTE_FATTY_LIVER_OF_PREGNANCY"] = "acute_fatty_liver_of_pregnancy";
    AcuteLiverFailureCause["REYES_SYNDROME"] = "reyes_syndrome";
})(AcuteLiverFailureCause || (exports.AcuteLiverFailureCause = AcuteLiverFailureCause = {}));
var MalignantDiseaseOfTheLiverCause;
(function (MalignantDiseaseOfTheLiverCause) {
    MalignantDiseaseOfTheLiverCause["HEPATOCELLULAR_CARCINOMA"] = "hepatocellular_carcinoma";
    MalignantDiseaseOfTheLiverCause["CARCINOID_TUMOUR"] = "carcinoid_tumour";
    MalignantDiseaseOfTheLiverCause["ISLET_CELL_TUMOUR"] = "islet_cell_tumour";
    MalignantDiseaseOfTheLiverCause["EPITHELIOID_HEMANGIOENDOTHELIOMA"] = "epithelioid_hemangioendothelioma";
    MalignantDiseaseOfTheLiverCause["CHOLANGIOCARCINOMA"] = "cholangiocarcinoma";
})(MalignantDiseaseOfTheLiverCause || (exports.MalignantDiseaseOfTheLiverCause = MalignantDiseaseOfTheLiverCause = {}));
var MetabolicLiverDiseaseCause;
(function (MetabolicLiverDiseaseCause) {
    MetabolicLiverDiseaseCause["WILSONS_DISEASE"] = "wilsons_disease";
    MetabolicLiverDiseaseCause["HEREDITARY_HEMOCHROMATOSIS"] = "hereditary_hemochromatosis";
    MetabolicLiverDiseaseCause["ALPHA1_ANTITRYPSIN_DEFICIENCY"] = "alpha1_antitrypsin_deficiency";
    MetabolicLiverDiseaseCause["GLYCOGEN_STORAGE_DISEASE"] = "glycogen_storage_disease";
    MetabolicLiverDiseaseCause["CYSTIC_FIBROSIS"] = "cystic_fibrosis";
    MetabolicLiverDiseaseCause["GLYCOGEN_STORAGE_DISEASE_I_IV"] = "glycogen_storage_disease_I_IV";
    MetabolicLiverDiseaseCause["CRIGLER_NAJJAR_SYNDROME"] = "crigler-najjar_syndrome";
    MetabolicLiverDiseaseCause["GALACTOSEMIA_TYPE1"] = "galactosemia_type1";
    MetabolicLiverDiseaseCause["HYPEROXALURIA"] = "hyperoxaluria";
    MetabolicLiverDiseaseCause["FAMILIAL_HOMOZYGOUS_HYPERCHOLESTEROLEMIA"] = "familial_homozygous_hypercholesterolemia";
    MetabolicLiverDiseaseCause["HEMOPHILIA_A_B"] = "hemophilia_a_b";
})(MetabolicLiverDiseaseCause || (exports.MetabolicLiverDiseaseCause = MetabolicLiverDiseaseCause = {}));
var VascularDiseasesOfTheLiverCause;
(function (VascularDiseasesOfTheLiverCause) {
    VascularDiseasesOfTheLiverCause["BUDD_CHIARI_SYNDROME"] = "budd_chiari_syndrome";
    VascularDiseasesOfTheLiverCause["VENO_OCCLUSIVE_DISEASE"] = "veno_occlusive_disease";
    VascularDiseasesOfTheLiverCause["CHOLESTATIC_LIVER_DISEASE"] = "cholestatic_liver_disease";
    VascularDiseasesOfTheLiverCause["PRIMARY_BILIARY_CIRRHOSIS"] = "primary_biliary_cirrhosis";
    VascularDiseasesOfTheLiverCause["PRIMARY_SCLEROSING_CHOLANGITIS"] = "primary_sclerosing_cholangitis";
    VascularDiseasesOfTheLiverCause["SECONDARY_BILIARY_CIRRHOSIS"] = "secondary_biliary_cirrhosis";
    VascularDiseasesOfTheLiverCause["BILIARY_ATRESIA"] = "biliary_atresia";
    VascularDiseasesOfTheLiverCause["ALAGILLE_SYNDROME"] = "alagille_syndrome";
    VascularDiseasesOfTheLiverCause["BYLERS_DISEASE"] = "bylers_disease";
})(VascularDiseasesOfTheLiverCause || (exports.VascularDiseasesOfTheLiverCause = VascularDiseasesOfTheLiverCause = {}));
var MiscellaneousCause;
(function (MiscellaneousCause) {
    MiscellaneousCause["ADULT_POLYCYSTIC_LIVER_DISEASE"] = "adult_polycystic_liver_disease";
    MiscellaneousCause["NODULAR_REGENERATIVE_HYPERPLASIA"] = "nodular_regenerative_hyperplasia";
    MiscellaneousCause["CAROLIS_DISEASE"] = "carolis_disease";
    MiscellaneousCause["SEVERE_GRAFT_VERSUS_HOST_DISEASE"] = "severe_graft_versus_host_disease";
    MiscellaneousCause["AMYLOIDOSIS"] = "amyloidosis";
    MiscellaneousCause["SARCOIDOSIS"] = "sarcoidosis";
    MiscellaneousCause["HEPATIC_TRAUMA"] = "hepatic_trauma";
})(MiscellaneousCause || (exports.MiscellaneousCause = MiscellaneousCause = {}));
exports.hepatologyTypeMessages = {
    [HepatologyType.HEPATOLOGY_NO_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.hepatologyType.HEPATOLOGY_NO_DISEASE",
        defaultMessage: "Nincs hepatológiai betegség"
    },
    [HepatologyType.ACUTE_CHRONIC_LIVER_FAILURE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.hepatologyType.ACUTE_CHRONIC_LIVER_FAILURE",
        defaultMessage: "Akut / krónikus májelégtelenség"
    },
    [HepatologyType.NONALCOHOLIC_FATTY_LIVER_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.hepatologyType.NONALCOHOLIC_FATTY_LIVER_DISEASE",
        defaultMessage: "Nem alkoholos zsírmáj"
    },
    [HepatologyType.ALCOHOLIC_LIVER_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.hepatologyType.ALCOHOLIC_LIVER_DISEASE",
        defaultMessage: "Alkohol okozta májbetegség"
    },
    [HepatologyType.MALIGNANT_DISEASE_OF_THE_LIVER]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.hepatologyType.MALIGNANT_DISEASE_OF_THE_LIVER",
        defaultMessage: "Máj malignus betegsége"
    },
    [HepatologyType.METABOLIC_LIVER_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.hepatologyType.METABOLIC_LIVER_DISEASE",
        defaultMessage: "Metabolikus májbetegség"
    },
    [HepatologyType.VASCULAR_DISEASES_OF_THE_LIVER]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.hepatologyType.VASCULAR_DISEASES_OF_THE_LIVER",
        defaultMessage: "Vaszkuláris eredet"
    },
    [HepatologyType.MISCELLANEOUS]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.hepatologyType.MISCELLANEOUS",
        defaultMessage: "Egyéb"
    }
};
exports.acuteLiverFailureCauseMessages = {
    [AcuteLiverFailureCause.HEPATITIS_A]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.HEPATITIS_A",
        defaultMessage: "Hepatitis A"
    },
    [AcuteLiverFailureCause.ACETAMINOPHEN]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.ACETAMINOPHEN",
        defaultMessage: "Acetaminophen"
    },
    [AcuteLiverFailureCause.AUTOIMMUNE_HEPATITIS]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.AUTOIMMUNE_HEPATITIS",
        defaultMessage: "Autoimmun hepatitis"
    },
    [AcuteLiverFailureCause.HEPATITIS_B]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.HEPATITIS_B",
        defaultMessage: "Hepatitis B"
    },
    [AcuteLiverFailureCause.HEPATITIS_C]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.HEPATITIS_C",
        defaultMessage: "Hepatitis C"
    },
    [AcuteLiverFailureCause.CRYPTOGENIC_DRUGS]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.CRYPTOGENIC_DRUGS",
        defaultMessage: "Cryptogenic Drugs"
    },
    [AcuteLiverFailureCause.HEPATITIS_D]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.HEPATITIS_D",
        defaultMessage: "Hepatitis D"
    },
    [AcuteLiverFailureCause.WILSONS_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.WILSONS_DISEASE",
        defaultMessage: "Wilson kór"
    },
    [AcuteLiverFailureCause.BUDD_CHIARI_SYNDROME]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.BUDD_CHIARI_SYNDROME",
        defaultMessage: "Budd-Chiari szindróma"
    },
    [AcuteLiverFailureCause.FATTY_INFILTRATION]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.FATTY_INFILTRATION",
        defaultMessage: "Zsírmáj"
    },
    [AcuteLiverFailureCause.ACUTE_FATTY_LIVER_OF_PREGNANCY]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.ACUTE_FATTY_LIVER_OF_PREGNANCY",
        defaultMessage: "Terhességi akut zsírmáj"
    },
    [AcuteLiverFailureCause.REYES_SYNDROME]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.acuteLiverFailureCause.REYES_SYNDROME",
        defaultMessage: "Reye szindróma"
    }
};
exports.malignantDiseaseOfTheLiverCauseMessages = {
    [MalignantDiseaseOfTheLiverCause.HEPATOCELLULAR_CARCINOMA]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.malignantDiseaseOfTheLiverCause.HEPATOCELLULAR_CARCINOMA",
        defaultMessage: "Hepatocelluláris carcinoma"
    },
    [MalignantDiseaseOfTheLiverCause.CARCINOID_TUMOUR]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.malignantDiseaseOfTheLiverCause.CARCINOID_TUMOUR",
        defaultMessage: "Carcinoid tumor"
    },
    [MalignantDiseaseOfTheLiverCause.ISLET_CELL_TUMOUR]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.malignantDiseaseOfTheLiverCause.ISLET_CELL_TUMOUR",
        defaultMessage: "Szigetsejt tumor"
    },
    [MalignantDiseaseOfTheLiverCause.EPITHELIOID_HEMANGIOENDOTHELIOMA]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.malignantDiseaseOfTheLiverCause.EPITHELIOID_HEMANGIOENDOTHELIOMA",
        defaultMessage: "Epitheloid hemangioendothelioma"
    },
    [MalignantDiseaseOfTheLiverCause.CHOLANGIOCARCINOMA]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.malignantDiseaseOfTheLiverCause.CHOLANGIOCARCINOMA",
        defaultMessage: "Cholangiocarcinoma"
    }
};
exports.metabolicLiverDiseaseCauseMessages = {
    [MetabolicLiverDiseaseCause.WILSONS_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.WILSONS_DISEASE",
        defaultMessage: "Wilson kór"
    },
    [MetabolicLiverDiseaseCause.HEREDITARY_HEMOCHROMATOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.HEREDITARY_HEMOCHROMATOSIS",
        defaultMessage: "Örökletes hemochromatosis"
    },
    [MetabolicLiverDiseaseCause.ALPHA1_ANTITRYPSIN_DEFICIENCY]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.ALPHA1_ANTITRYPSIN_DEFICIENCY",
        defaultMessage: "Alpha1 antitripszin hiány"
    },
    [MetabolicLiverDiseaseCause.GLYCOGEN_STORAGE_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.GLYCOGEN_STORAGE_DISEASE",
        defaultMessage: "Glycogen tárolási betegség"
    },
    [MetabolicLiverDiseaseCause.CYSTIC_FIBROSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.CYSTIC_FIBROSIS",
        defaultMessage: "Cisztás fibrózis"
    },
    [MetabolicLiverDiseaseCause.GLYCOGEN_STORAGE_DISEASE_I_IV]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.GLYCOGEN_STORAGE_DISEASE_I_IV",
        defaultMessage: "Glycogen tárolási betegség I-IV"
    },
    [MetabolicLiverDiseaseCause.CRIGLER_NAJJAR_SYNDROME]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.CRIGLER_NAJJAR_SYNDROME",
        defaultMessage: "Crigler-Najjar szindróma"
    },
    [MetabolicLiverDiseaseCause.GALACTOSEMIA_TYPE1]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.GALACTOSEMIA_TYPE1",
        defaultMessage: "Galactosemia 1-es típus"
    },
    [MetabolicLiverDiseaseCause.HYPEROXALURIA]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.HYPEROXALURIA",
        defaultMessage: "Hyperoxaluria"
    },
    [MetabolicLiverDiseaseCause.FAMILIAL_HOMOZYGOUS_HYPERCHOLESTEROLEMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.FAMILIAL_HOMOZYGOUS_HYPERCHOLESTEROLEMIA",
        defaultMessage: "Familiaris homozigóta hypercholesterinaemia"
    },
    [MetabolicLiverDiseaseCause.HEMOPHILIA_A_B]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.metabolicLiverDiseaseCause.HEMOPHILIA_A_B",
        defaultMessage: "Hemophilia A és B"
    }
};
exports.vascularDiseasesOfTheLiverCauseMessages = {
    [VascularDiseasesOfTheLiverCause.BUDD_CHIARI_SYNDROME]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.vascularDiseasesOfTheLiverCause.BUDD_CHIARI_SYNDROME",
        defaultMessage: "Budd-Chiari szindróma"
    },
    [VascularDiseasesOfTheLiverCause.VENO_OCCLUSIVE_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.vascularDiseasesOfTheLiverCause.VENO_OCCLUSIVE_DISEASE",
        defaultMessage: "Veno-occlusive betegség"
    },
    [VascularDiseasesOfTheLiverCause.CHOLESTATIC_LIVER_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.vascularDiseasesOfTheLiverCause.CHOLESTATIC_LIVER_DISEASE",
        defaultMessage: "Cholestaticus májbetegség"
    },
    [VascularDiseasesOfTheLiverCause.PRIMARY_BILIARY_CIRRHOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.vascularDiseasesOfTheLiverCause.PRIMARY_BILIARY_CIRRHOSIS",
        defaultMessage: "Primer Biliáris cirrhosis"
    },
    [VascularDiseasesOfTheLiverCause.PRIMARY_SCLEROSING_CHOLANGITIS]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.vascularDiseasesOfTheLiverCause.PRIMARY_SCLEROSING_CHOLANGITIS",
        defaultMessage: "Primer sclerotisalo cholangitis"
    },
    [VascularDiseasesOfTheLiverCause.SECONDARY_BILIARY_CIRRHOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.vascularDiseasesOfTheLiverCause.SECONDARY_BILIARY_CIRRHOSIS",
        defaultMessage: "Szekunder biliáris cirrhosis"
    },
    [VascularDiseasesOfTheLiverCause.BILIARY_ATRESIA]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.vascularDiseasesOfTheLiverCause.BILIARY_ATRESIA",
        defaultMessage: "Biliáris atresia"
    },
    [VascularDiseasesOfTheLiverCause.ALAGILLE_SYNDROME]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.vascularDiseasesOfTheLiverCause.ALAGILLE_SYNDROME",
        defaultMessage: "Alagille szindróma"
    },
    [VascularDiseasesOfTheLiverCause.BYLERS_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.vascularDiseasesOfTheLiverCause.BYLERS_DISEASE",
        defaultMessage: "Byler betegség"
    }
};
exports.miscellaneousCauseMessages = {
    [MiscellaneousCause.ADULT_POLYCYSTIC_LIVER_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.miscellaneousCause.ADULT_POLYCYSTIC_LIVER_DISEASE",
        defaultMessage: "Felnőtkori policisztás májbetegség"
    },
    [MiscellaneousCause.NODULAR_REGENERATIVE_HYPERPLASIA]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.miscellaneousCause.NODULAR_REGENERATIVE_HYPERPLASIA",
        defaultMessage: "Noduláris regeneratív hyperplasia"
    },
    [MiscellaneousCause.CAROLIS_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.miscellaneousCause.CAROLIS_DISEASE",
        defaultMessage: "Caroli betegség"
    },
    [MiscellaneousCause.SEVERE_GRAFT_VERSUS_HOST_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.miscellaneousCause.SEVERE_GRAFT_VERSUS_HOST_DISEASE",
        defaultMessage: "Súlyos graft versus host betegség"
    },
    [MiscellaneousCause.AMYLOIDOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.miscellaneousCause.AMYLOIDOSIS",
        defaultMessage: "Amyloidosis"
    },
    [MiscellaneousCause.SARCOIDOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.miscellaneousCause.SARCOIDOSIS",
        defaultMessage: "Sarcoidosis"
    },
    [MiscellaneousCause.HEPATIC_TRAUMA]: {
        id: "ktx.transplantationScreening.medicalHistory.hepatologyDiseases.miscellaneousCause.HEPATIC_TRAUMA",
        defaultMessage: "Májtrauma"
    }
};
const hepatologyType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HepatologyType.HEPATOLOGY_NO_DISEASE)
        .interpretation({ vocab: "ktx", code: "hepatology_no_disease" })
        .tag({ vocab: "ktx", code: "hepatology_disease" }),
    schema_1.Schema.singleChoiceItem(HepatologyType.ACUTE_CHRONIC_LIVER_FAILURE)
        .interpretation({ vocab: "ktx", code: "acute_chronic_liver_failure" })
        .tag({ vocab: "ktx", code: "hepatology_disease" }),
    schema_1.Schema.singleChoiceItem(HepatologyType.NONALCOHOLIC_FATTY_LIVER_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "nonalcoholic_fatty_liver_disease"
    })
        .tag({ vocab: "ktx", code: "hepatology_disease" }),
    schema_1.Schema.singleChoiceItem(HepatologyType.ALCOHOLIC_LIVER_DISEASE)
        .interpretation({ vocab: "ktx", code: "alcoholic_liver_disease" })
        .tag({ vocab: "ktx", code: "hepatology_disease" }),
    schema_1.Schema.singleChoiceItem(HepatologyType.MALIGNANT_DISEASE_OF_THE_LIVER)
        .interpretation({
        vocab: "ktx",
        code: "malignant_disease_of_the_liver"
    })
        .tag({ vocab: "ktx", code: "hepatology_disease" }),
    schema_1.Schema.singleChoiceItem(HepatologyType.METABOLIC_LIVER_DISEASE)
        .interpretation({ vocab: "ktx", code: "metabolic_liver_disease" })
        .tag({ vocab: "ktx", code: "hepatology_disease" }),
    schema_1.Schema.singleChoiceItem(HepatologyType.VASCULAR_DISEASES_OF_THE_LIVER)
        .interpretation({
        vocab: "ktx",
        code: "vascular_diseases_of_the_liver"
    })
        .tag({ vocab: "ktx", code: "hepatology_disease" }),
    schema_1.Schema.singleChoiceItem(HepatologyType.MISCELLANEOUS)
        .interpretation({ vocab: "ktx", code: "miscellaneous" })
        .tag({ vocab: "ktx", code: "hepatology_disease" })
])
    .transferInterpretationsAndTagsToParent()
    .expiration(31536000);
const acuteLiverFailureCause = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hepatologyType} === “acute_chronic_liver_failure”`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.HEPATITIS_A),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.ACETAMINOPHEN),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.AUTOIMMUNE_HEPATITIS),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.HEPATITIS_B),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.HEPATITIS_C),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.CRYPTOGENIC_DRUGS),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.HEPATITIS_D),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.WILSONS_DISEASE),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.BUDD_CHIARI_SYNDROME),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.FATTY_INFILTRATION),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.ACUTE_FATTY_LIVER_OF_PREGNANCY),
    schema_1.Schema.singleChoiceItem(AcuteLiverFailureCause.REYES_SYNDROME)
]));
const malignantDiseaseOfTheLiverCause = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hepatologyType} === "malignant_disease_of_the_liver"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(MalignantDiseaseOfTheLiverCause.HEPATOCELLULAR_CARCINOMA),
    schema_1.Schema.singleChoiceItem(MalignantDiseaseOfTheLiverCause.CARCINOID_TUMOUR),
    schema_1.Schema.singleChoiceItem(MalignantDiseaseOfTheLiverCause.ISLET_CELL_TUMOUR),
    schema_1.Schema.singleChoiceItem(MalignantDiseaseOfTheLiverCause.EPITHELIOID_HEMANGIOENDOTHELIOMA),
    schema_1.Schema.singleChoiceItem(MalignantDiseaseOfTheLiverCause.CHOLANGIOCARCINOMA)
]));
const metabolicLiverDiseaseCause = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hepatologyType} === "metabolic_liver_disease"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.WILSONS_DISEASE),
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.HEREDITARY_HEMOCHROMATOSIS),
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.ALPHA1_ANTITRYPSIN_DEFICIENCY),
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.GLYCOGEN_STORAGE_DISEASE),
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.CYSTIC_FIBROSIS),
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.GLYCOGEN_STORAGE_DISEASE_I_IV),
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.CRIGLER_NAJJAR_SYNDROME),
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.GALACTOSEMIA_TYPE1),
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.HYPEROXALURIA),
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.FAMILIAL_HOMOZYGOUS_HYPERCHOLESTEROLEMIA),
    schema_1.Schema.singleChoiceItem(MetabolicLiverDiseaseCause.HEMOPHILIA_A_B)
]));
const vascularDiseasesOfTheLiverCause = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hepatologyType} === "vascular_diseases_of_the_liver"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(VascularDiseasesOfTheLiverCause.BUDD_CHIARI_SYNDROME),
    schema_1.Schema.singleChoiceItem(VascularDiseasesOfTheLiverCause.VENO_OCCLUSIVE_DISEASE),
    schema_1.Schema.singleChoiceItem(VascularDiseasesOfTheLiverCause.CHOLESTATIC_LIVER_DISEASE),
    schema_1.Schema.singleChoiceItem(VascularDiseasesOfTheLiverCause.PRIMARY_BILIARY_CIRRHOSIS),
    schema_1.Schema.singleChoiceItem(VascularDiseasesOfTheLiverCause.PRIMARY_SCLEROSING_CHOLANGITIS),
    schema_1.Schema.singleChoiceItem(VascularDiseasesOfTheLiverCause.SECONDARY_BILIARY_CIRRHOSIS),
    schema_1.Schema.singleChoiceItem(VascularDiseasesOfTheLiverCause.BILIARY_ATRESIA),
    schema_1.Schema.singleChoiceItem(VascularDiseasesOfTheLiverCause.ALAGILLE_SYNDROME),
    schema_1.Schema.singleChoiceItem(VascularDiseasesOfTheLiverCause.BYLERS_DISEASE)
]));
const miscellaneousCause = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hepatologyType} === "miscellaneous"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(MiscellaneousCause.ADULT_POLYCYSTIC_LIVER_DISEASE),
    schema_1.Schema.singleChoiceItem(MiscellaneousCause.NODULAR_REGENERATIVE_HYPERPLASIA),
    schema_1.Schema.singleChoiceItem(MiscellaneousCause.CAROLIS_DISEASE),
    schema_1.Schema.singleChoiceItem(MiscellaneousCause.SEVERE_GRAFT_VERSUS_HOST_DISEASE),
    schema_1.Schema.singleChoiceItem(MiscellaneousCause.AMYLOIDOSIS),
    schema_1.Schema.singleChoiceItem(MiscellaneousCause.SARCOIDOSIS),
    schema_1.Schema.singleChoiceItem(MiscellaneousCause.HEPATIC_TRAUMA)
]));
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object().default({}).sealed(true).properties({
    hepatologyType,
    acuteLiverFailureCause,
    malignantDiseaseOfTheLiverCause,
    metabolicLiverDiseaseCause,
    vascularDiseasesOfTheLiverCause,
    miscellaneousCause,
    comment
});
